import { useDispatch as useDispatchRedux, UseDispatch } from "react-redux";
import { RootAction } from "Reducers/reducers";
import { Dispatch } from "redux";

export const useDispatch = useDispatchRedux as UseDispatch<
  Dispatch<RootAction>
>;
